import React from 'react';
import PropTypes from 'prop-types';
import styles from './region-entity-table.module.scss';
import { humanizeNumber } from '../../helpers/formatters';

const HeaderCell = ({ label, value }) => {
  return (
    <div style={{ height: 45, marginBottom: 20 }}>
      <div style={{ display: 'inline-block', height: 40 }}>
        <div className={styles.tableHeaderText}>
          {label.includes('capacity') && humanizeNumber(value, 'ml', true)}
          {label.includes('dam') && humanizeNumber(value, 'number', true)}
          {label.includes('storage') &&
            humanizeNumber(value[0] / 100, 'percentage', true) +
              '-' +
              humanizeNumber(value[1] / 100, 'percentage', true)}
          {label.includes('service') && humanizeNumber(value, 'currency', true)}
          {label.includes('consumption') &&
            humanizeNumber(value, 'currency', true)}
        </div>
        <div className={styles.headerCellSubscript}>{label}</div>
      </div>
    </div>
  );
};

HeaderCell.propTypes = {
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.array]),
};

export default HeaderCell;



// WEBPACK FOOTER //
// ./src/components/region-entity-table/header-cell.js